import { defineStore } from 'pinia'

export const useCurrentRoleStore = defineStore('currentRoleStore', {
  state: () => ({
    currentRole: {} as SchoolRole,
    currentStudent: {} as SchoolUser | null,
    currentGrade: 'B1' as string,
  }),
  getters: {
    getCurrentRole: (state) => {
      return () => state.currentRole
    },
    getCurrentStudent: (state) => {
      return () => state.currentStudent
    },
    getCurrentGrade: (state) => {
      return () => state.currentGrade
    },
  },
  actions: {
    setCurrentRole(role: SchoolRole) {
      this.currentRole = role
    },
    setCurrentStudent(student: SchoolUser | null) {
      this.currentStudent = student
    },
    setCurrentGrade(grade: string) {
      this.currentGrade = grade
    },
    deleteCurrentRole() {
      this.currentRole = {} as SchoolRole
      this.currentStudent = null
      this.currentGrade = ''
    },
  },
})
